import { twJoin } from 'tailwind-merge';
import { useFieldArray, useFormContext } from 'react-hook-form';

import { CourseStudioFormFields } from '../CourseStudio.hooks';
import { StudioPermissions } from '@/enums/VersioningStatus';
import LessonBlockDetail from './LessonBlockDetail';
import { scrollBarYClassName } from '@/utils/scrollBarClassName';
import { CourseStudioProps } from '../info/CourseStudioInfo.hooks';

type Props = CourseStudioProps & {
  studioPermissions: StudioPermissions;
  coursePathId?: number;
};

export default function CourseStudioBlocksDetailsStep(props: Props) {
  const { control, watch } = useFormContext<CourseStudioFormFields>();

  const { fields: blocks } = useFieldArray({
    control,
    name: 'lessonBlocks',
  });

  return (
    <article className="flex flex-col gap-2.5">
      <ul
        className={twJoin(
          'flex flex-col gap-2.5 max-h-[calc(100vh-20rem)]',
          scrollBarYClassName,
        )}
      >
        {blocks.map((block, blockIndex) => (
          <LessonBlockDetail
            key={block.id || block.tempId}
            block={block}
            blockIndex={blockIndex}
            blocks={watch('lessonBlocks')}
            {...props}
          />
        ))}
      </ul>
    </article>
  );
}
